const IconOilDrop = () => (
  <svg width="25" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 51" aria-labelledby="title">
    {/* <title id="title">Umbrella</title> */}

    <image href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAwAQMAAADTmjOZAAAAAXNSR0IB2cksfwAAAAZQTFRFAAAA6msUncGKqAAAAAJ0Uk5TAP9bkSK1AAAAY0lEQVR4nHXOsREAERSE4b0RCJWgFKVRmlKUIBQYezycm7m55Av/XQABeHEdYkcdUkc/mLyxZeNqx7cN2SNkgCIjNJlgBpbMgwK3qPCLNuEf/kOdAUlJ1Iy8DMmuPADHIVdwA2GjbZ11M/UlAAAAAElFTkSuQmCC" />
  </svg>
);

export default IconOilDrop;
